/* eslint-disable react/jsx-no-duplicate-props */
import React, { useState, useEffect, useRef } from "react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import { Modal, Button, Table } from "antd";
import { message } from "antd";
import { FiChevronRight, FiSearch, FiX, FiRefreshCw, FiDollarSign, FiEdit, FiEye, FiFileText, FiImage, FiDownload } from "react-icons/fi";
import { BaseInput, BaseSelect, BaseButton, BaseTextarea } from "../../components/ui";
import { imagesend } from "../../components/imagepath";
import { Link } from 'react-router-dom';
import espacioService from '../../services/espacioService';
import inmuebleService from '../../services/inmuebleService';
import personaService from '../../services/personaService';
import pisoService from '../../services/pisoService';
import pagoService from '../../services/pagoService';
import documentoService from '../../services/documentoService';
import '@fortawesome/fontawesome-free/css/all.min.css';
import moment from 'moment';
import { plusicon, refreshicon, searchnormal, pdficon, pdficon3, pdficon4 } from '../../components/imagepath';
import contratoService from '../../services/contratoService';

const ContabilidadPagos = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    inmueble_id: '',
    piso_id: '',
    espacioId: '',
    inquilinoId: '',
    monto: '',
    fechaPago: '',
    fechaRealPago: '',
    metodoPago: '',
    estado: '',
    observaciones: ''
  });

  // Estados de filtros mejorados
  const [searchTerm, setSearchTerm] = useState('');
  const [searchType, setSearchType] = useState('dni'); // 'dni' o 'nombre'
  const [selectedMonth, setSelectedMonth] = useState(null); // Por defecto mostrar todos los meses

  // Estados para datos
  const [inmuebles, setInmuebles] = useState([]);
  const [pagos, setPagos] = useState([]);
  const [todosPagos, setTodosPagos] = useState([]); // Lista completa sin filtrar
  const [pagosFiltrados, setPagosFiltrados] = useState([]);
  const [pagoSeleccionado, setPagoSeleccionado] = useState(null);
  const [loading2, setLoading2] = useState(false);
  const [documento, setDocumento] = useState(null);
  const [documentoUrl, setDocumentoUrl] = useState("");
  const [documentoError, setDocumentoError] = useState(false);
  const [loadingDoc, setLoadingDoc] = useState(false);
  const fileInputRef = useRef(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalEditVisible, setModalEditVisible] = useState(false);
  const [modalViewVisible, setModalViewVisible] = useState(false);
  const [pagoVisualizando, setPagoVisualizando] = useState(null);
  const [modalRegistroVisible, setModalRegistroVisible] = useState(false);
  const [pagoARegistrar, setPagoARegistrar] = useState(null);
  const [comprobanteFile, setComprobanteFile] = useState(null);
  const [loadingRegistro, setLoadingRegistro] = useState(false);
  const [metodoPagoRegistro, setMetodoPagoRegistro] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [updatedData, setUpdatedData] = useState(null);
  const [showInactiveContractModal, setShowInactiveContractModal] = useState(false);
  const [inactiveContractInfo, setInactiveContractInfo] = useState(null);
  
  const metodosPago = [
    { value: 'efectivo', label: 'Efectivo' },
    { value: 'transferencia', label: 'Transferencia Bancaria' },
    { value: 'paypal', label: 'Paypal' },
    { value: 'tarjeta', label: 'Tarjeta de Crédito/Débito' },
    { value: 'yape', label: 'Yape' },
    { value: 'plin', label: 'Plin' },
  ];

  const estadosPago = [
    { value: 'pendiente', label: 'Pendiente' },
    { value: 'pagado', label: 'Pagado' },
    { value: 'vencido', label: 'Vencido' },
    { value: 'cancelado', label: 'Cancelado' }
  ];

  const tiposPago = [
    { value: 'alquiler', label: 'Alquiler' },
    { value: 'mantenimiento', label: 'Mantenimiento' },
    { value: 'servicios', label: 'Servicios' },
    { value: 'otros', label: 'Otros' }
  ];

  const meses = [
    { value: null, label: 'Todos los meses' },
    { value: 0, label: 'Enero' },
    { value: 1, label: 'Febrero' },
    { value: 2, label: 'Marzo' },
    { value: 3, label: 'Abril' },
    { value: 4, label: 'Mayo' },
    { value: 5, label: 'Junio' },
    { value: 6, label: 'Julio' },
    { value: 7, label: 'Agosto' },
    { value: 8, label: 'Septiembre' },
    { value: 9, label: 'Octubre' },
    { value: 10, label: 'Noviembre' },
    { value: 11, label: 'Diciembre' }
  ];

  // Función para aplicar todos los filtros
  const aplicarFiltros = () => {
    let resultados = [...todosPagos];

    // Filtro por mes
    if (selectedMonth !== null) {
      resultados = resultados.filter(pago => {
        if (!pago.fecha_pago) return false;
        const fechaPago = new Date(pago.fecha_pago);
        return fechaPago.getMonth() === selectedMonth;
      });
    }

    // Filtro por búsqueda de texto
    if (searchTerm.trim()) {
      const searchLower = searchTerm.toLowerCase();
      resultados = resultados.filter(pago => {
        if (searchType === 'dni') {
          return pago.inquilino_dni && pago.inquilino_dni.toLowerCase().includes(searchLower);
        } else {
          const nombreCompleto = `${pago.inquilino_nombre || ''} ${pago.inquilino_apellido || ''}`.toLowerCase();
          return nombreCompleto.includes(searchLower);
        }
      });
    }

    setPagosFiltrados(resultados);
    setPagos(resultados);
    
    return resultados; // Devolver los resultados para evaluación inmediata
  };

  // useEffect para cargar datos iniciales
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        const inmueblesData = await inmuebleService.obtenerInmuebles();
        setInmuebles(inmueblesData);
        
        const pagosData = await pagoService.obtenerPagos();
        const pagosArray = Array.isArray(pagosData) ? pagosData : [];
        
        setTodosPagos(pagosArray);
        // Mostrar todos los pagos por defecto (sin filtros)
        setPagosFiltrados(pagosArray);
        setPagos(pagosArray);
        
      } catch (error) {
        console.error('Error en la carga inicial:', error);
        setError('Error al cargar los datos iniciales');
        setTodosPagos([]);
        setPagosFiltrados([]);
        setPagos([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Función para aplicar filtros manualmente
  const buscarInquilino = () => {
    setLoading2(true);
    try {
      const resultados = aplicarFiltros();
      
      if (resultados.length === 0 && (searchTerm.trim() || selectedMonth !== null)) {
        message.warning('No se encontraron pagos con los filtros aplicados');
      } else if (resultados.length > 0 && (searchTerm.trim() || selectedMonth !== null)) {
        message.success(`Se encontraron ${resultados.length} pago${resultados.length !== 1 ? 's' : ''} con los filtros aplicados`);
      } else if (resultados.length > 0) {
        message.info(`Mostrando todos los pagos (${resultados.length})`);
      }
    } finally {
      setLoading2(false);
    }
  };

  // Función para limpiar filtros y mostrar todos los pagos
  const limpiarFiltros = () => {
    setSearchTerm('');
    setSearchType('dni');
    setSelectedMonth(null);
    
    // Mostrar todos los pagos sin filtros
    setPagosFiltrados(todosPagos);
    setPagos(todosPagos);
    
    message.success('Filtros limpiados. Mostrando todos los pagos.');
  };

  const refreshData = async () => {
    try {
      setLoading(true);
      const pagosData = await pagoService.obtenerPagos();
      const pagosArray = Array.isArray(pagosData) ? pagosData : [];
      setTodosPagos(pagosArray);
      
      // Si no hay filtros activos, mostrar todos los datos
      // Si hay filtros activos, mantener la vista filtrada
      if (!searchTerm && selectedMonth === null) {
        setPagosFiltrados(pagosArray);
        setPagos(pagosArray);
      } else {
        // Reaplicar filtros con los nuevos datos
        setTimeout(() => {
          aplicarFiltros();
        }, 100);
      }
      
      message.success("Datos actualizados correctamente");
    } catch (error) {
      message.error("Error al actualizar los datos");
      setTodosPagos([]);
      setPagosFiltrados([]);
      setPagos([]);
    } finally {
      setLoading(false);
    }
  };

  const seleccionarPago = (pago) => {
    setPagoSeleccionado(pago);
    
    // Para determinar los valores iniciales de los selects
    const metodoPagoSeleccionado = metodosPago.find(m => m.value === pago.metodo_pago) || null;
    const estadoSeleccionado = estadosPago.find(e => e.value === pago.estado) || null;
    
    // Obtener la fecha actual para la fecha real de pago en formato YYYY-MM-DD
    const fechaActual = new Date();
    const anioActual = fechaActual.getFullYear();
    const mesActual = String(fechaActual.getMonth() + 1).padStart(2, '0');
    const diaActual = String(fechaActual.getDate()).padStart(2, '0');
    
    // Formato para base de datos: YYYY-MM-DD
    const fechaRealActual = `${anioActual}-${mesActual}-${diaActual}`;
    
    // Convertir fecha_pago de YYYY-MM-DD a DD-MM-YYYY para mostrar
    let fechaPagoFormateada = '';
    
    if (pago.fecha_pago) {
      const fecha = new Date(pago.fecha_pago);
      const dia = fecha.getDate().toString().padStart(2, '0');
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const anio = fecha.getFullYear();
      fechaPagoFormateada = `${dia}-${mes}-${anio}`;
    }
    
    
    setFormData({
      inmueble_id: '',
      espacioId: pago.contrato_id || '',
      inquilinoId: pago.inquilino_id || '',
      monto: pago.monto,
      fechaPago: pago.fecha_pago || '',
      fechaRealPago: fechaRealActual, // Usar la fecha actual del ordenador
      metodoPago: pago.metodo_pago,
      estado: pago.estado,
      observaciones: pago.observacion || ''
    });
    
    // Abrir el modal de pago
    setModalVisible(true);
  };

  const editarPago = (pago) => {
    setPagoSeleccionado(pago);
    
    setFormData({
      inmueble_id: '',
      espacioId: pago.contrato_id || '',
      inquilinoId: pago.inquilino_id || '',
      monto: pago.monto,
      fechaPago: pago.fecha_pago ? moment(pago.fecha_pago).format('YYYY-MM-DD') : '',
      fechaRealPago: pago.fecha_real_pago ? moment(pago.fecha_real_pago).format('YYYY-MM-DD') : '',
      metodoPago: pago.metodo_pago,
      estado: pago.estado,
      observaciones: pago.observacion || ''
    });
    
    // Abrir el modal de edición
    setModalEditVisible(true);
  };

  // Función para verificar si un archivo existe
  const verificarExistenciaArchivo = async (url) => {
    try {
      const response = await fetch(url, { method: 'HEAD' });
      return response.ok;
    } catch (error) {
      console.error('Error al verificar existencia del archivo:', error);
      return false;
    }
  };

  // Función para ver detalles de un pago
  const verPago = async (pago) => {
    setPagoVisualizando(pago);
    setDocumentoError(false);
    setLoadingDoc(true);
    
    try {
      const documentos = await documentoService.obtenerDocumentosPorTipo(pago.id, 'pago');
      
      if (documentos && documentos.length > 0) {
        const doc = documentos[0];
        
        setDocumento({
          id: doc.id,
          nombre: doc.nombre,
          url: doc.url,
          key: doc.key,
          tipo: doc.tipo || 'application/pdf'
        });
        
        setDocumentoError(false);
      } else {
        setDocumento(null);
      }
    } catch (error) {
      console.error('Error al obtener el documento:', error);
      setDocumento(null);
      setDocumentoError(true);
    } finally {
      setLoadingDoc(false);
    }
    
    setModalViewVisible(true);
  };

  // Función para descargar directamente el documento
  const descargarDocumento = async (ruta, nombreArchivo) => {
    try {
      // Verificar que el documento existe
      const existeArchivo = await verificarExistenciaArchivo(ruta);
      
      if (!existeArchivo) {
        alert('No se puede descargar el documento porque no existe o no está accesible.');
        return;
      }
      
      // Obtener el contenido del archivo
      const response = await fetch(ruta);
      const blob = await response.blob();
      
      // Crear URL para el blob
      const url = window.URL.createObjectURL(blob);
      
      // Crear un enlace oculto y simular clic
      const link = document.createElement('a');
      link.href = url;
      link.download = nombreArchivo; // Nombre de archivo sugerido para la descarga
      document.body.appendChild(link);
      link.click();
      
      // Limpiar
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error al descargar el documento:', error);
      alert('Ha ocurrido un error al intentar descargar el documento. Consulta la consola para más detalles.');
    }
  };

  // Función para abrir el documento en una nueva ventana pero preservando la sesión
  const abrirDocumentoEnNuevaVentana = (ruta) => {
    try {
      // Crear una nueva ventana y escribir contenido HTML para mostrar el documento
      const nuevaVentana = window.open('', '_blank');
      if (nuevaVentana) {
        nuevaVentana.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>Visor de Documento</title>
            <style>
              body, html { margin: 0; padding: 0; height: 100%; overflow: hidden; }
              .documento-container { width: 100%; height: 100%; }
              .pdf-viewer { width: 100%; height: 100%; border: none; }
              .image-viewer { max-width: 100%; max-height: 100%; display: block; margin: 0 auto; }
              .error-message { 
                display: flex; 
                justify-content: center; 
                align-items: center; 
                height: 100%; 
                font-family: Arial, sans-serif;
                color: #721c24;
                background-color: #f8d7da;
                padding: 20px;
                border-radius: 5px;
                text-align: center;
              }
            </style>
          </head>
          <body>
            <div class="documento-container">
              <embed src="${ruta}" type="application/pdf" class="pdf-viewer" />
            </div>
          </body>
          </html>
        `);
        nuevaVentana.document.close();
      } else {
        alert('El navegador ha bloqueado la apertura de una nueva ventana. Por favor, permite las ventanas emergentes para este sitio.');
      }
    } catch (error) {
      console.error('Error al abrir el documento en nueva ventana:', error);
      alert('Ha ocurrido un error al intentar abrir el documento. Intenta descargarlo en su lugar.');
    }
  };

  const handleCancelEdit = () => {
    setModalEditVisible(false);
    setPagoSeleccionado(null);
    setFormData({
      inmueble_id: '',
      piso_id: '',
      espacioId: '',
      inquilinoId: '',
      monto: '',
      fechaPago: '',
      fechaRealPago: '',
      metodoPago: '',
      estado: '',
      observaciones: ''
    });
  };

  const handleCancelView = () => {
    setModalViewVisible(false);
    setPagoVisualizando(null);
    setDocumentoUrl("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFilterMonthChange = (e) => {
    const val = e.target.value;
    setSelectedMonth(val === '' ? null : Number(val));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setDocumento(file);
    }
  };

  const handleCancel = () => {
    // Cerrar el modal y resetear los campos
    setModalVisible(false);
    setFormData({
      inmueble_id: '',
      piso_id: '',
      espacioId: '',
      inquilinoId: '',
      monto: '',
      fechaPago: '',
      fechaRealPago: '',
      metodoPago: '',
      estado: '',
      observaciones: ''
    });
    setDocumento(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    setPagoSeleccionado(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!pagoSeleccionado) {
      alert('Debe seleccionar un pago primero');
      return;
    }

    if (!documento) {
      alert('Debe cargar un documento de respaldo para el pago');
      return;
    }

    // Validar que el archivo sea PDF
    if (documento.type !== 'application/pdf') {
      alert('Solo se permiten archivos PDF');
      return;
    }
    
    try {
      // Formatear fechas correctamente (solo YYYY-MM-DD sin zona horaria)
      let fechaPagoFormateada = '';
      let fechaRealFormateada = '';
      
      // Formatear fecha_pago si existe
      if (pagoSeleccionado.fecha_pago) {
        const fecha = new Date(pagoSeleccionado.fecha_pago);
        const anio = fecha.getFullYear();
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const dia = String(fecha.getDate()).padStart(2, '0');
        fechaPagoFormateada = `${anio}-${mes}-${dia}`;
      }
      
      // Formatear fecha_real_pago (fecha actual)
      const fechaActual = new Date(formData.fechaRealPago);
      const anioActual = fechaActual.getFullYear();
      const mesActual = String(fechaActual.getMonth() + 1).padStart(2, '0');
      const diaActual = String(fechaActual.getDate()).padStart(2, '0');
      fechaRealFormateada = `${anioActual}-${mesActual}-${diaActual}`;
      const horaActual = String(fechaActual.getHours()).padStart(2, '0');
      const minutosActual = String(fechaActual.getMinutes()).padStart(2, '0');
      const segundosActual = String(fechaActual.getSeconds()).padStart(2, '0');
      
      // console.log('Fecha pago formateada:', fechaPagoFormateada);
      // console.log('Fecha real formateada:', fechaRealFormateada);
      
      // Crear objeto con datos del pago
      const pagoData = {
        contrato_id: pagoSeleccionado.contrato_id,
        monto: formData.monto,
        metodo_pago: formData.metodoPago,
        tipo_pago: pagoSeleccionado.tipo_pago || 'alquiler',
        estado: formData.estado,
        fecha_pago: fechaPagoFormateada,
        fecha_real_pago: fechaRealFormateada,
        observacion: formData.observaciones
      };
      
      // console.log('Datos del pago a actualizar:', pagoData);

      // Actualizar primero el pago
      const pagoActualizado = await pagoService.actualizarPago(pagoSeleccionado.id, pagoData);
      
      try {
        // Verificar que el ID del pago sea válido y esté disponible
        if (!pagoSeleccionado.id) {
          throw new Error('El ID del pago no es válido');
        }
        
        // Asegurarse de que el ID sea un entero
        const idPago = parseInt(pagoSeleccionado.id);
        if (isNaN(idPago)) {
          throw new Error('El ID del pago no es un número válido');
        }
        
        // Crear un nombre de archivo cifrado basado en la fecha actual y el ID del pago
        // Formato: pago_YYYYMMDD_HHMMSS_ID.pdf
        const nombreArchivo = `pago_${anioActual}${mesActual}${diaActual}_${horaActual}${minutosActual}${segundosActual}_${idPago}.pdf`;
        
        // Crear un objeto File con el nuevo nombre
        const nuevoArchivo = new File([documento], nombreArchivo, { type: documento.type });
        
       
        
        // Incluir un timeout para evitar problemas de concurrencia
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // Pasar un parámetro adicional para indicar que no queremos subcarpeta
        const respuestaArchivo = await documentoService.subirArchivo(
          nuevoArchivo, 
          idPago, 
          'pago',
          { usarCarpetaComun: true }  // Parámetro adicional para indicar que use /pago/ en lugar de /pago/{id}/
        );
     
        
        // Registrar los metadatos del documento con la nueva ruta en /pago/
        const documentoData = {
          nombre: nombreArchivo,
          ruta: respuestaArchivo.ruta || `/pago/${nombreArchivo}`,
          documentable_id: idPago,
          documentable_type: 'pago'
        };

        const respuestaDocumento = await documentoService.crearDocumento(documentoData);
        //console.log('Documento registrado correctamente:', respuestaDocumento);        
        alert('Pago actualizado correctamente y documento subido al servidor.');
        
        // Reset form and search
        setFormData({
          inmueble_id: '',
          piso_id: '',
          espacioId: '',
          inquilinoId: '',
          monto: '',
          fechaPago: '',
          fechaRealPago: '',
          metodoPago: '',
          estado: '',
          observaciones: ''
        });
        setDocumento(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        setSearchTerm('');
        // Cerrar modal
        setModalVisible(false);
        // Recargar los pagos
        const todosLosPagos = await pagoService.obtenerPagos();
        const pagosArray = Array.isArray(todosLosPagos) ? todosLosPagos : [];
        setTodosPagos(pagosArray);
        
        // Si no hay filtros activos, mostrar todos los datos
        if (!searchTerm && selectedMonth === null) {
          setPagosFiltrados(pagosArray);
          setPagos(pagosArray);
        } else {
          // Reaplicar filtros con los nuevos datos
          setTimeout(() => {
            aplicarFiltros();
          }, 100);
        }
        
        setPagoSeleccionado(null);
        
      } catch (docError) {
        console.error('Error al registrar el documento:', docError);
        alert(`Error al registrar el documento: ${docError.message || 'Revise la consola para más detalles'}`);
        throw docError;
      }
      
    } catch (error) {
      console.error('Error detallado:', error);
      if (error.response && error.response.data) {
        alert(`Error: ${error.response.data.mensaje || error.message}`);
      } else {
        alert('Error al actualizar el pago o registrar el documento');
      }
    }
  };

  const handleSubmitEdit = async (e) => {
    e.preventDefault();
    
    if (!pagoSeleccionado) {
      alert('Debe seleccionar un pago primero');
      return;
    }
    
    try {
      // Formatear fechas correctamente (solo YYYY-MM-DD sin zona horaria)
      let fechaPagoFormateada = '';
      let fechaRealFormateada = '';
      
      // Formatear fecha_pago si existe
      if (formData.fechaPago) {
        const fecha = new Date(formData.fechaPago);
        const anio = fecha.getFullYear();
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const dia = String(fecha.getDate()).padStart(2, '0');
        fechaPagoFormateada = `${anio}-${mes}-${dia}`;
      }
      
      // Formatear fecha_real_pago si existe
      if (formData.fechaRealPago) {
        const fechaActual = new Date(formData.fechaRealPago);
        const anioActual = fechaActual.getFullYear();
        const mesActual = String(fechaActual.getMonth() + 1).padStart(2, '0');
        const diaActual = String(fechaActual.getDate()).padStart(2, '0');
        fechaRealFormateada = `${anioActual}-${mesActual}-${diaActual}`;
      }
      
      // Crear objeto con datos del pago
      const pagoData = {
        contrato_id: pagoSeleccionado.contrato_id,
        monto: formData.monto,
        metodo_pago: formData.metodoPago,
        tipo_pago: pagoSeleccionado.tipo_pago || 'alquiler',
        estado: formData.estado,
        fecha_pago: fechaPagoFormateada,
        fecha_real_pago: fechaRealFormateada,
        observacion: formData.observaciones
      };
      

      // Actualizar el pago
      const pagoActualizado = await pagoService.actualizarPago(pagoSeleccionado.id, pagoData);
      
      // Guardar los datos actualizados y mostrar el modal de éxito
      setUpdatedData({
        ...pagoData,
        inquilino_nombre: pagoSeleccionado.inquilino_nombre,
        inquilino_apellido: pagoSeleccionado.inquilino_apellido
      });
      
      // Reset form y cerrar modal
      setFormData({
        inmueble_id: '',
        piso_id: '',
        espacioId: '',
        inquilinoId: '',
        monto: '',
        fechaPago: '',
        fechaRealPago: '',
        metodoPago: '',
        estado: '',
        observaciones: ''
      });
      
      setModalEditVisible(false);
      setShowSuccessModal(true);
      
    } catch (error) {
      console.error('Error al actualizar el pago:', error);
      message.error('Error al actualizar el pago');
    }
  };

  // Función para manejar el cierre del modal de éxito
  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    // Recargar los pagos
    cargarTodosPagos();
  };

  // Función para cargar todos los pagos
  const cargarTodosPagos = async () => {
    try {
      setLoading2(true);
      
      const pagosData = await pagoService.obtenerPagos();
      const pagosArray = Array.isArray(pagosData) ? pagosData : [];
      setTodosPagos(pagosArray);
      
      // Si no hay filtros activos, mostrar todos los datos
      if (!searchTerm && selectedMonth === null) {
        setPagosFiltrados(pagosArray);
        setPagos(pagosArray);
      } else {
        // Reaplicar filtros si hay filtros activos
        setTimeout(() => {
          aplicarFiltros();
        }, 100);
      }
      
    } catch (error) {
      console.error('Error al cargar todos los pagos:', error);
      message.error('Error al cargar los pagos');
      setTodosPagos([]);
      setPagosFiltrados([]);
      setPagos([]);
    } finally {
      setLoading2(false);
    }
  };

  // Función para manejar el registro de pago
  const handleRegistrarPago = async (pago) => {
    console.log('=== INICIO DE REGISTRO DE PAGO ===');
    console.log('Datos del pago recibidos:', pago);
    console.log('ID del contrato a verificar:', pago.contrato_id);

    try {
      console.log('Intentando obtener información del contrato...');
      // Verificar si el contrato está activo usando el contrato_id
      const contrato = await contratoService.obtenerContratoPorId(pago.contrato_id);
      
      console.log('Respuesta del servicio de contrato:', contrato);
      
      if (!contrato) {
        console.error('No se encontró el contrato');
        message.error('No se pudo obtener la información del contrato');
        return;
      }

      console.log('Estado del contrato:', contrato.estado);

      if (contrato.estado === 'inactivo' || contrato.estado === 'cancelado') {
        console.log('Contrato inactivo/cancelado detectado - Bloqueando registro de pago');
        setInactiveContractInfo({
          inquilino: `${pago.inquilino_nombre} ${pago.inquilino_apellido}`,
          contratoId: contrato.id,
          fechaInicio: contrato.fecha_inicio,
          fechaFin: contrato.fecha_fin,
          estado: contrato.estado
        });
        setShowInactiveContractModal(true);
        return;
      }

      console.log('Contrato activo - Procediendo con el registro de pago');
      // Si el contrato está activo, proceder con el registro
      setPagoARegistrar(pago);
      setComprobanteFile(null);
      setMetodoPagoRegistro(pago.metodo_pago || null);
      setModalRegistroVisible(true);
      console.log('Modal de registro abierto');
    } catch (error) {
      console.error('Error en el proceso de registro de pago:', error);
      console.error('Detalles del error:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      message.error('Error al verificar el estado del contrato');
    }
    console.log('=== FIN DE REGISTRO DE PAGO ===');
  };

  // Función para manejar el cambio del archivo de comprobante
  const handleComprobanteChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setComprobanteFile(file);
    }
  };

  // Función para manejar el envío del registro de pago
  const handleSubmitRegistro = async (e) => {
    e.preventDefault();
    
    try {
      // Validar campos obligatorios
      if (!pagoARegistrar) {
        message.error('No se ha seleccionado ningún pago');
        return;
      }

      if (!comprobanteFile) {
        message.error('Debe subir un comprobante de pago');
        return;
      }

      // Validar que si hay documento, sea un PDF
      if (comprobanteFile.type !== 'application/pdf') {
        message.error('Solo se permiten archivos PDF como documentos de respaldo');
        return;
      }

      if (!metodoPagoRegistro) {
        message.error('Debe seleccionar el método de pago');
        return;
      }

      setLoadingRegistro(true);
      
      // Actualizar el pago primero
      const pagoData = {
        contrato_id: pagoARegistrar.contrato_id,
        monto: pagoARegistrar.monto,
        tipo_pago: pagoARegistrar.tipo_pago || 'alquiler',
        estado: 'pagado',
        metodo_pago: metodoPagoRegistro,
        fecha_pago: pagoARegistrar.fecha_pago,
        fecha_real_pago: new Date().toISOString().split('T')[0],
        observacion: ''
      };

      // Actualizar el pago
      await pagoService.actualizarPago(pagoARegistrar.id, pagoData);
      
      // Si hay documento, subirlo
      if (comprobanteFile) {
        try {
          const respuestaArchivo = await documentoService.subirArchivo(
            comprobanteFile,
            pagoARegistrar.id,
            'pago'
          );

          if (!respuestaArchivo || !respuestaArchivo.id) {
            throw new Error('No se recibió una respuesta válida del servidor al subir el archivo');
          }

          message.success('Documento subido exitosamente');
        } catch (docError) {
          console.error('Error al subir documento:', docError);
          message.error(`El pago se registró correctamente, pero hubo un error al subir el documento: ${docError.message || ''}`);
        }
      }

      message.success('Pago registrado correctamente');
      setModalRegistroVisible(false);
      
      // Limpiar el formulario
      setComprobanteFile(null);
      setMetodoPagoRegistro(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      
      // Actualizar los datos
      await refreshData();

    } catch (error) {
      console.error('Error al registrar el pago:', error);
      message.error('Error al registrar el pago');
    } finally {
      setLoadingRegistro(false);
    }
  };

  // Reemplazar la definición de columns con el formato de Table de antd
  const columns = [
    {
      title: "Inquilino",
      key: "inquilino",
      render: (text, record) => `${record.inquilino_nombre || ''} ${record.inquilino_apellido || ''}`,
      sorter: (a, b) => {
        const nombreA = `${a.inquilino_nombre || ''} ${a.inquilino_apellido || ''}`;
        const nombreB = `${b.inquilino_nombre || ''} ${b.inquilino_apellido || ''}`;
        return nombreA.localeCompare(nombreB);
      }
    },
    {
      title: "DNI",
      dataIndex: "inquilino_dni",
      sorter: (a, b) => a.inquilino_dni?.localeCompare(b.inquilino_dni || ''),
      render: (text) => text || "N/A",
    },
    {
      title: "Inmueble",
      dataIndex: "nombre_inmueble",
      sorter: (a, b) => a.nombre_inmueble?.localeCompare(b.nombre_inmueble || ''),
      render: (text) => text || "N/A",
    },
    {
      title: "Piso",
      dataIndex: "piso",
      sorter: (a, b) => a.piso?.localeCompare(b.piso || ''),
      render: (text) => text || "N/A",
    },
    {
      title: "Habitación",
      dataIndex: "nombre_habitacion",
      sorter: (a, b) => a.nombre_habitacion?.localeCompare(b.nombre_habitacion || ''),
      render: (text) => text || "N/A",
    },
    {
      title: "Monto",
      dataIndex: "monto",
      sorter: (a, b) => (parseFloat(a.monto) || 0) - (parseFloat(b.monto) || 0),
      render: (monto) => (monto !== undefined && monto !== null ? `S/ ${parseFloat(monto).toFixed(2)}` : "N/A"),
    },
    {
      title: "Fecha Programada",
      dataIndex: "fecha_pago",
      sorter: (a, b) => new Date(a.fecha_pago || 0) - new Date(b.fecha_pago || 0),
      render: (fecha) => fecha ? new Date(fecha).toLocaleDateString() : "N/A",
    },
    {
      title: "Fecha Real",
      dataIndex: "fecha_real_pago",
      sorter: (a, b) => new Date(a.fecha_real_pago || 0) - new Date(b.fecha_real_pago || 0),
      render: (fecha) => fecha ? new Date(fecha).toLocaleDateString() : "-",
    },
    {
      title: "Método de Pago",
      dataIndex: "metodo_pago",
      sorter: (a, b) => a.metodo_pago?.localeCompare(b.metodo_pago || ''),
      render: (text) => text || "N/A",
    },
    {
      title: "Estado",
      dataIndex: "estado",
      sorter: (a, b) => a.estado?.localeCompare(b.estado || ''),
      render: (text) => text || "N/A",
    },
    {
      title: "Acciones",
      key: "acciones",
      render: (text, record) => (
        <div className="text-center">
          <BaseButton
            type="button"
            variant="success"
            size="sm"
            className="me-1"
            icon={<FiDollarSign />}
            onClick={() => handleRegistrarPago(record)}
            title="Registrar Pago"
            disabled={record.estado === 'pagado'}
          />
          <BaseButton
            type="button"
            variant="warning"
            size="sm"
            className="me-1"
            icon={<FiEdit />}
            onClick={() => editarPago(record)}
            title="Editar"
          />
          <BaseButton
            type="button"
            variant="primary"
            size="sm"
            icon={<FiEye />}
            onClick={() => verPago(record)}
            title="Ver"
          />
        </div>
      ),
    }
  ];

  const paginationComponentOptions = {
    rowsPerPageText: 'Filas por página:',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todos',
  };

  // Función para validar la existencia del documento
  const validarDocumento = async (rutaDocumento) => {
    if (!rutaDocumento) {
      alert('La ruta del documento no está disponible');
      return false;
    }

    try {
      const existeArchivo = await verificarExistenciaArchivo(rutaDocumento);
      if (!existeArchivo) {
        alert('El documento no existe o no está accesible');
        return false;
      }
      return true;
    } catch (error) {
      console.error('Error al validar el documento:', error);
      alert('Error al verificar el documento');
      return false;
    }
  };

  // Utilidad para extraer la ruta relativa de un documento
  const getRutaRelativa = (ruta) => {
    if (!ruta) return '';
    // Si la ruta es absoluta, extrae solo la parte después de /documentos/
    const idx = ruta.indexOf('/documentos/');
    if (idx !== -1) {
      return ruta.substring(idx + 1); // sin el primer slash
    }
    // Si ya es relativa, la retorna igual
    return ruta.replace(/^\//, '');
  };

  // Función para ver documento directamente usando el servicio
  const handleViewDocument = async (rutaDocumento) => {
    try {
      if (!rutaDocumento) {
        throw new Error('Ruta del documento no disponible');
      }
      
      const response = await documentoService.verDocumento(rutaDocumento);
      if (response.url) {
        window.open(response.url, '_blank');
      } else {
        throw new Error('URL no disponible en la respuesta');
      }
    } catch (error) {
      console.error('Error al ver el documento:', error);
      message.error('Error al abrir el documento. Por favor, intente descargarlo.');
    }
  };

  // Función para descargar documento directamente usando el servicio
  const handleDownloadDocument = async (rutaDocumento, nombreArchivo) => {
    try {
      if (!rutaDocumento) {
        throw new Error('Ruta del documento no disponible');
      }
      
      const response = await documentoService.descargarDocumento(rutaDocumento, nombreArchivo);
      if (response.url) {
        // Crear un enlace temporal para la descarga
        const link = document.createElement('a');
        link.href = response.url;
        link.setAttribute('download', response.nombre || nombreArchivo || 'documento.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        throw new Error('URL no disponible en la respuesta');
      }
    } catch (error) {
      console.error('Error al descargar el documento:', error);
      message.error('Error al descargar el documento. Por favor, intente más tarde.');
    }
  };

  if (loading) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Header />
      <Sidebar id='menu-item6' id1='menu-items6' activeClassName='contabilidad-pagos'/>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Contabilidad</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FiChevronRight />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Registrar Pago</li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">
                  
                <div className="page-table-header mb-2">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Lista de Pagos</h3>
                          <div className="doctor-search-blk">
                                                         <div className="top-nav-search table-search-blk">
                               <span className="text-muted">
                                 {loading ? 'Cargando...' : 
                                   pagosFiltrados.length === todosPagos.length ? 
                                   `Mostrando todos los pagos (${todosPagos.length})` :
                                   `Mostrando ${pagosFiltrados.length} de ${todosPagos.length} pagos filtrados`
                                 }
                               </span>
                             </div>
                            <div className="add-group">
                              <BaseButton
                                type="button"
                                variant="primary"
                                className="ms-2 doctor-refresh"
                                onClick={refreshData}
                                title="Actualizar datos"
                                loading={loading}
                                icon={<FiRefreshCw />}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col-12">
                     {/* <div className="form-heading d-flex justify-content-between align-items-center">
                        <h3>Lista de Pagos</h3>
                        <div>
                          <button 
                            type="button" 
                            className="btn btn-info me-2"
                            onClick={cargarTodosPagos}
                            disabled={loading2}
                          >
                            {loading2 ? (
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            ) : (
                              <FiRefreshCw className="me-2" />
                            )}
                            Recargar Todos los Pagos
                          </button>
                         <span className="text-muted">
                            {loading2 ? 'Cargando pagos...' : Array.isArray(pagos) ? 
                              `${pagos.length} ${pagos.length === 1 ? 'pago' : 'pagos'} encontrados` : ''}
                          </span>
                        </div>
                      </div>*/}
                      <div className="row">
                    <div className="col-12 mb-3">
                      <div className="bg-light p-3 rounded">
                        <h5 className="mb-3">
                          <FiSearch className="me-2" />
                          Filtros de Búsqueda
                        </h5>
                        <div className="row">
                          <div className="col-12 col-md-3">
                            <BaseSelect
                              label="Mes"
                              value={selectedMonth ?? ''}
                              onChange={handleFilterMonthChange}
                              placeholder="Seleccionar mes"
                              options={meses.map((m) => ({
                                value: m.value ?? '',
                                label: m.label,
                              }))}
                            />
                          </div>

                          <div className="col-12 col-md-2">
                            <BaseSelect
                              label="Buscar por"
                              value={searchType}
                              onChange={(e) => setSearchType(e.target.value)}
                              options={[
                                { value: 'dni', label: 'DNI' },
                                { value: 'nombre', label: 'Nombre' },
                              ]}
                            />
                          </div>

                          <div className="col-12 col-md-4">
                            <BaseInput
                              label="Término de búsqueda"
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  buscarInquilino();
                                }
                              }}
                              placeholder={searchType === 'dni' ? 'Ingrese DNI del inquilino' : 'Ingrese nombre del inquilino'}
                            />
                          </div>
                          
                          <div className="col-12 col-md-3">
                            <div className="form-group">
                              <label>&nbsp;</label>
                              <div className="d-flex gap-2">
                                <BaseButton
                                  type="button"
                                  variant="primary"
                                  className="flex-fill"
                                  loading={loading2}
                                  icon={<FiSearch />}
                                  onClick={buscarInquilino}
                                  disabled={loading2}
                                >
                                  Buscar
                                </BaseButton>
                                <BaseButton
                                  type="button"
                                  variant="secondary"
                                  className="flex-fill"
                                  icon={<FiX />}
                                  onClick={limpiarFiltros}
                                  disabled={!searchTerm && selectedMonth === null}
                                >
                                  Limpiar
                                </BaseButton>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                      <div className="table-responsive doctor-list">
                        <Table
                          columns={columns}
                          dataSource={pagosFiltrados}
                          rowKey="id"
                          pagination={{
                            total: pagosFiltrados.length,
                            pageSize: 10,
                            showTotal: (total, range) =>
                              `Mostrando ${range[0]} a ${range[1]} de ${total} registros`,
                            showSizeChanger: true,
                            showQuickJumper: true,
                            sizeChangerText: 'Filas por página',
                            jumpPrevText: 'Anterior',
                            jumpNextText: 'Siguiente'
                          }}
                          loading={loading || loading2}
                          locale={{
                            emptyText: todosPagos.length === 0 ? 
                              'No hay pagos registrados en el sistema' :
                              pagosFiltrados.length === 0 ? 
                              'No se encontraron pagos con los filtros aplicados. Presione "Buscar" para aplicar filtros o "Limpiar" para ver todos los pagos.' :
                              'No hay datos para mostrar'
                          }}
                        />
                      </div>
                    </div>
                  </div>

                 
                </div>
              </div>
            </div>
          </div>
          
          {/* Modal de actualización de pago (Pagar) */}
          <Modal
            title={<><FiDollarSign className="me-2" /> Registrar Pago</>}
            open={modalVisible}
            onCancel={handleCancel}
            footer={null}
            width={800}
            destroyOnClose={true}
            centered
            maskClosable={false}
            key={pagoSeleccionado ? `pago-modal-${pagoSeleccionado.id}` : 'pago-modal'}
          >
            {pagoSeleccionado && (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <BaseInput
                      label="Inquilino (Solo lectura)"
                      readOnly
                      value={`${pagoSeleccionado.inquilino_nombre || ''} ${pagoSeleccionado.inquilino_apellido || ''}`}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <BaseInput
                      label="DNI (Solo lectura)"
                      readOnly
                      value={pagoSeleccionado.inquilino_dni || ''}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <BaseInput
                      label="Monto"
                      name="monto"
                      required
                      readOnly
                      value={formData.monto}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <BaseInput
                      label="Fecha de Pago (Solo lectura)"
                      readOnly
                      value={pagoSeleccionado.fecha_pago ? new Date(pagoSeleccionado.fecha_pago).toLocaleDateString() : ''}
                      helperText="Fecha programada del pago"
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <BaseInput
                      label="Fecha Real de Pago (Fecha actual)"
                      readOnly
                      value={formData.fechaRealPago ? new Date(formData.fechaRealPago).toLocaleDateString() : new Date().toLocaleDateString()}
                      helperText="Fecha actual del sistema para el registro del pago"
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <BaseSelect
                      label="Método de Pago"
                      name="metodoPago"
                      required
                      value={formData.metodoPago}
                      onChange={handleChange}
                      placeholder="Seleccionar método de pago"
                      options={metodosPago}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <BaseSelect
                      label="Estado"
                      name="estado"
                      required
                      value={formData.estado}
                      onChange={handleChange}
                      placeholder="Seleccionar estado"
                      options={estadosPago}
                    />
                  </div>

                  <div className="col-12">
                    <BaseInput
                      label="Documento de Respaldo"
                      type="file"
                      required
                      onChange={handleFileChange}
                      ref={fileInputRef}
                      helperText="Suba un documento de respaldo para este pago (factura, comprobante, etc.)"
                    />
                  </div>

                  <div className="col-12">
                    <BaseTextarea
                      label="Observaciones"
                      name="observaciones"
                      rows={3}
                      value={formData.observaciones}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-12">
                    <div className="doctor-submit text-end d-flex justify-content-end gap-2">
                      <BaseButton type="submit" variant="primary">
                        Actualizar Pago
                      </BaseButton>
                      <BaseButton type="button" variant="secondary" onClick={handleCancel}>
                        Cancelar
                      </BaseButton>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </Modal>
          
          {/* Modal de edición de pago */}
          <Modal
            title={<><FiEdit className="me-2" /> Editar Pago</>}
            open={modalEditVisible}
            onCancel={handleCancelEdit}
            footer={null}
            width={800}
            destroyOnClose={true}
            centered
            maskClosable={false}
            key={pagoSeleccionado ? `pago-edit-modal-${pagoSeleccionado.id}` : 'pago-edit-modal'}
          >
            {pagoSeleccionado && (
              <form onSubmit={handleSubmitEdit}>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <BaseInput
                      label="Inquilino (Solo lectura)"
                      readOnly
                      value={`${pagoSeleccionado.inquilino_nombre || ''} ${pagoSeleccionado.inquilino_apellido || ''}`}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <BaseInput
                      label="DNI (Solo lectura)"
                      readOnly
                      value={pagoSeleccionado.inquilino_dni || ''}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <BaseInput
                      label="Monto"
                      name="monto"
                      required
                      restrict="decimal"
                      value={formData.monto}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <BaseInput
                      label="Fecha de Pago"
                      name="fechaPago"
                      type="date"
                      required
                      value={formData.fechaPago}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <BaseInput
                      label="Fecha Real de Pago"
                      name="fechaRealPago"
                      type="date"
                      value={formData.fechaRealPago}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <BaseSelect
                      label="Método de Pago"
                      name="metodoPago"
                      required
                      value={formData.metodoPago}
                      onChange={handleChange}
                      placeholder="Seleccionar método de pago"
                      options={metodosPago}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <BaseSelect
                      label="Estado"
                      name="estado"
                      required
                      value={formData.estado}
                      onChange={handleChange}
                      placeholder="Seleccionar estado"
                      options={estadosPago}
                    />
                  </div>

                  <div className="col-12">
                    <BaseTextarea
                      label="Observaciones"
                      name="observaciones"
                      rows={3}
                      value={formData.observaciones}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-12">
                    <div className="doctor-submit text-end d-flex justify-content-end gap-2">
                      <BaseButton type="submit" variant="primary">
                        <FiEdit className="me-1" /> Actualizar Pago
                      </BaseButton>
                      <BaseButton type="button" variant="secondary" onClick={handleCancelEdit}>
                        <FiX className="me-1" /> Cancelar
                      </BaseButton>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </Modal>
          
          {/* Modal de visualización de pago */}
          <Modal
            title={<><FiEye className="me-2" /> Detalles del Pago</>}
            open={modalViewVisible}
            onCancel={handleCancelView}
            footer={[
              <BaseButton
                key="close"
                type="button"
                variant="secondary"
                icon={<FiX />}
                onClick={handleCancelView}
              >
                Cerrar
              </BaseButton>
            ]}
            width={800}
            destroyOnClose={true}
            centered
            maskClosable={false}
            key={pagoVisualizando ? `pago-view-modal-${pagoVisualizando.id}` : 'pago-view-modal'}
          >
            {pagoVisualizando && (
              <div className="row">
                <div className="col-12 mb-4">
                  <h5 className="text-primary">Información del Inquilino</h5>
                  <hr />
                  <div className="row">
                    <div className="col-md-6">
                      <p><strong>Nombre:</strong> {`${pagoVisualizando.inquilino_nombre || ''} ${pagoVisualizando.inquilino_apellido || ''}`}</p>
                    </div>
                    <div className="col-md-6">
                      <p><strong>DNI:</strong> {pagoVisualizando.inquilino_dni || ''}</p>
                    </div>
                  </div>
                </div>
                
                <div className="col-12 mb-4">
                  <h5 className="text-primary">Información del Espacio</h5>
                  <hr />
                  <div className="row">
                    <div className="col-md-6">
                      <p><strong>Inmueble:</strong> {pagoVisualizando.nombre_inmueble || 'N/A'}</p>
                    </div>
                    <div className="col-md-6">
                      <p><strong>Piso:</strong> {pagoVisualizando.piso || 'N/A'}</p>
                    </div>
                    <div className="col-md-6">
                      <p><strong>Habitación:</strong> {pagoVisualizando.nombre_habitacion || 'N/A'}</p>
                    </div>
                  </div>
                </div>

                <div className="col-12 mb-4">
                  <h5 className="text-primary">Detalles del Pago</h5>
                  <hr />
                  <div className="row">
                    <div className="col-md-6">
                      <p><strong>Monto:</strong> {pagoVisualizando.monto || ''}</p>
                    </div>
                    <div className="col-md-6">
                      <p><strong>Método de Pago:</strong> {pagoVisualizando.metodo_pago || ''}</p>
                    </div>
                    <div className="col-md-6">
                      <p><strong>Fecha Programada:</strong> {pagoVisualizando.fecha_pago ? new Date(pagoVisualizando.fecha_pago).toLocaleDateString() : ''}</p>
                    </div>
                    <div className="col-md-6">
                      <p><strong>Fecha Real de Pago:</strong> {pagoVisualizando.fecha_real_pago ? new Date(pagoVisualizando.fecha_real_pago).toLocaleDateString() : '-'}</p>
                    </div>
                    <div className="col-md-6">
                      <p><strong>Estado:</strong> {pagoVisualizando.estado || ''}</p>
                    </div>
                    <div className="col-md-6">
                      <p><strong>Tipo de Pago:</strong> {pagoVisualizando.tipo_pago || 'Alquiler'}</p>
                    </div>
                    <div className="col-12">
                      <p><strong>Observaciones:</strong> {pagoVisualizando.observacion || '-'}</p>
                    </div>
                  </div>
                </div>
                
                {/* Sección de documento */}
                {pagoVisualizando.estado !== 'pendiente' && (
                  <div className="col-12">
                    <h5 className="text-primary">Documento Adjunto</h5>
                    <hr />
                    {loadingDoc && (
                      <div className="text-center p-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Cargando...</span>
                        </div>
                        <p className="mt-2">Buscando documento...</p>
                      </div>
                    )}
                    
                    {!loadingDoc && documento && !documentoError ? (
                      <div className="document-container p-3 border rounded">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <div className="document-info d-flex align-items-center">
                            <span className="document-icon me-3">
                              {documento.tipo === 'imagen' ? (
                                <FiImage size={24} className="text-primary" />
                              ) : (
                                <FiFileText size={24} className="text-primary" />
                              )}
                            </span>
                            <span className="document-name">
                              {documento.nombre}
                            </span>
                          </div>
                          <div className="document-actions">
                            <BaseButton
                              type="button"
                              variant="outline"
                              size="sm"
                              className="me-2"
                              icon={<FiDownload />}
                              onClick={() => handleDownloadDocument(documento.id || documento.key, documento.nombre)}
                            >
                              Descargar
                            </BaseButton>
                            <BaseButton
                              type="button"
                              variant="primary"
                              size="sm"
                              icon={<FiEye />}
                              onClick={() => handleViewDocument(documento.id || documento.key)}
                            >
                              Ver documento
                            </BaseButton>
                          </div>
                        </div>
                      </div>
                    ) : !loadingDoc && documentoError && (
                      <div className="alert alert-warning">
                        <p className="mb-0">
                          <i className="fas fa-exclamation-triangle me-2"></i>
                          El documento no se encuentra disponible en estos momentos.
                        </p>
                        <p className="small mb-0 mt-2">
                          Esto puede deberse a que:
                        </p>
                        <ul className="small mb-0">
                          <li>El documento fue eliminado o movido</li>
                          <li>No tienes permisos para acceder al documento</li>
                          <li>La ruta del documento es incorrecta</li>
                        </ul>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </Modal>

          {/* Modal de Registro de Pago */}
          <Modal
            title={<><FiDollarSign className="me-2" /> Registrar Pago</>}
            open={modalRegistroVisible}
            onCancel={() => {
              setModalRegistroVisible(false);
              setComprobanteFile(null);
              setMetodoPagoRegistro(null);
              if (fileInputRef.current) {
                fileInputRef.current.value = '';
              }
            }}
            footer={null}
            width={600}
            destroyOnClose={true}
            centered
            maskClosable={false}
          >
            {pagoARegistrar && (
              <form onSubmit={handleSubmitRegistro}>
                <div className="row">
                  <div className="col-12 mb-3">
                    <BaseInput
                      label="Inquilino"
                      readOnly
                      value={`${pagoARegistrar.inquilino_nombre || ''} ${pagoARegistrar.inquilino_apellido || ''}`}
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <BaseInput
                      label="Monto"
                      readOnly
                      value={pagoARegistrar.monto}
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <BaseSelect
                      label="Método de Pago"
                      name="metodoPago"
                      required
                      value={metodoPagoRegistro || ''}
                      onChange={(e) => setMetodoPagoRegistro(e.target.value)}
                      placeholder="Seleccionar método de pago"
                      options={metodosPago}
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <BaseInput
                      label="Comprobante de Pago"
                      type="file"
                      required
                      accept=".pdf"
                      onChange={handleComprobanteChange}
                      ref={fileInputRef}
                      helperText="Suba el comprobante de pago en formato PDF"
                    />
                  </div>

                  <div className="col-12">
                    <div className="d-flex justify-content-end gap-2">
                      <BaseButton
                        type="button"
                        variant="secondary"
                        onClick={() => {
                          setModalRegistroVisible(false);
                          setComprobanteFile(null);
                          setMetodoPagoRegistro(null);
                          if (fileInputRef.current) {
                            fileInputRef.current.value = '';
                          }
                        }}
                      >
                        Cancelar
                      </BaseButton>
                      <BaseButton
                        type="submit"
                        variant="primary"
                        loading={loadingRegistro}
                        disabled={loadingRegistro || !comprobanteFile}
                      >
                        Registrar Pago
                      </BaseButton>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </Modal>

          {/* Modal de éxito */}
          <Modal
            title="¡Actualización Exitosa!"
            open={showSuccessModal}
            onOk={handleSuccessModalClose}
            onCancel={handleSuccessModalClose}
            okText="Aceptar"
            cancelButtonProps={{ style: { display: 'none' } }}
            centered
          >
            <div>
              <p>El pago se ha actualizado correctamente con los siguientes datos:</p>
              {updatedData && (
                <ul style={{ listStyleType: 'none', padding: '10px' }}>
                  <li><strong>Inquilino:</strong> {`${updatedData.inquilino_nombre} ${updatedData.inquilino_apellido}`}</li>
                  <li><strong>Monto:</strong> S/ {parseFloat(updatedData.monto).toFixed(2)}</li>
                  <li><strong>Método de Pago:</strong> {updatedData.metodo_pago}</li>
                  <li><strong>Estado:</strong> {updatedData.estado}</li>
                  <li><strong>Fecha de Pago:</strong> {updatedData.fecha_pago ? new Date(updatedData.fecha_pago).toLocaleDateString() : 'No especificada'}</li>
                  <li><strong>Fecha Real de Pago:</strong> {updatedData.fecha_real_pago ? new Date(updatedData.fecha_real_pago).toLocaleDateString() : 'No especificada'}</li>
                  <li><strong>Observaciones:</strong> {updatedData.observacion || 'No especificadas'}</li>
                </ul>
              )}
            </div>
          </Modal>

          {/* Modal de Contrato Inactivo */}
          <Modal
            title={<div className="text-danger"><i className="fas fa-exclamation-triangle me-2"></i>Contrato Inactivo</div>}
            open={showInactiveContractModal}
            onOk={() => setShowInactiveContractModal(false)}
            onCancel={() => setShowInactiveContractModal(false)}
            okText="Entendido"
            cancelButtonProps={{ style: { display: 'none' } }}
            centered
          >
            <div className="p-3">
              <div className="alert alert-danger mb-3">
                <i className="fas fa-ban me-2"></i>
                No se puede realizar el pago porque el contrato está inactivo o cancelado.
              </div>
              
              {inactiveContractInfo && (
                <div className="contract-details">
                  <h6 className="mb-3">Detalles del Contrato:</h6>
                  <ul className="list-unstyled">
                    <li><strong>Inquilino:</strong> {inactiveContractInfo.inquilino}</li>
                    <li><strong>ID del Contrato:</strong> {inactiveContractInfo.contratoId}</li>
                    <li><strong>Fecha de Inicio:</strong> {new Date(inactiveContractInfo.fechaInicio).toLocaleDateString()}</li>
                    <li><strong>Fecha de Fin:</strong> {new Date(inactiveContractInfo.fechaFin).toLocaleDateString()}</li>
                    <li><strong>Estado:</strong> {inactiveContractInfo.estado}</li>
                  </ul>
                </div>
              )}
              
              <div className="mt-3 text-muted">
                <small>
                  <i className="fas fa-info-circle me-1"></i>
                  Para realizar el pago, el contrato debe estar activo. Por favor, contacte al administrador si necesita activar el contrato.
                </small>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default ContabilidadPagos;